var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 47,
  height: 52,
  fill: "none",
  viewBox: "0 0 47 52"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1E82F0",
  d: "M43.119 19.745c4.79 2.78 4.79 9.73 0 12.51l-32.34 18.767C5.99 53.802 0 50.327 0 44.766V7.234C0 1.674 5.989-1.802 10.78.978z"
})));
export default SvgPlayFilled;